import du from '../utils/dom-utilities';

/**
 * TabPanel init
 *
 * @param {String} groupSelector - Css Selector
 * @param {String} tabSelector - Css Selector
 * @param {String} panelSelector - Css Selector
 * @return {Object[]} Array of groups contains panels and filters array
 */
export default function(groupSelector = '[data-tabgroup]',
                            filterSelector = '[data-tabfilter]',
                            panelSelector = '[data-tabpanel]' ) {

    return du.queryAll(groupSelector).map((group) => {
        const panels = du.queryAll(panelSelector, group);
        const filters = du.queryAll(filterSelector, group);
        filters.forEach((itemFilter) => {
            itemFilter.addEventListener('click', (event) => {
                event.preventDefault();
                switchTab(event.target, filters, panels);
            });
        });

        return {
            panels: panels,
            filters: filters
        };
    });
};

/**
 * Switch state class
 * @param {HTMLElement} filterActionNode
 * @param {HTMLElement[]} filters node array
 * @param {HTMLElement[]} panels node array
 */
function switchTab(filterActionNode, filters, panels) {
    panels.forEach((item) => {
        du.unsetClass(item, 'state--active');
    });

    filters.forEach((item) => {
        du.unsetClass(item, 'state--active');
    });

    du.setClass(filterActionNode, 'state--active');
    du.setClass(document.querySelector(filterActionNode.getAttribute('href')), 'state--active');
}



// WEBPACK FOOTER //
// ./src/main/js/components/tabPanel.js